import { setState } from './helpers'

const systemMutations = {
  SET_CONNECTIONS: setState('connections'),
  SET_CHECKS: setState('checks'),

  SET_ROLES: setState('roles'),
  SET_ROLE: setState('role'),
  SET_ROLES_SELECT: setState('rolesSelect'),

  SET_PERMISSIONS: setState('permissions'),
  SET_PERMISSIONS_MODEL: setState('permissionsModel'),
  SET_PERMISSIONS_SELECT: setState('permissionsSelect'),

  SET_FILTER: setState('filter'),
  SET_SETTING: setState('setting'),

  SET_FILES: setState('files'),
  SET_USER_FILES: setState('userFiles'),
  SET_FILE: setState('file'),
  SET_IMAGE_FILE: setState('imageFile'),
  SET_IMPORT: setState('import'),
  SET_IMPORT_SCHEMA: setState('importSchema'),

  SET_APPS: setState('apps'),
  SET_APP: setState('app'),
  SET_CAMPAIGNS: setState('campaigns'),
  SET_CAMPAIGN_TYPES: setState('campaignTypes'),
  SET_CAMPAIGN: setState('campaign'),

  SET_STATS: setState('stats'),
  SET_REQUEST_STATS: setState('requestStats'),

  SET_WHOLESALER_MANAGEMENT: setState('wholesalerManagements'),
  SET_DEFAULT_BANNERS: setState('defaultBanners'),
  SET_POINT_SETTINGS: setState('pointSettings'),
  SET_SHOP_LIMITS: setState('shopLimits'),
  SET_BONUS_GOALS: setState('bonusGoals'),

  SET_FEATURED_PRODUCTS: setState('featured_products'),

  SET_VOUCHER_SELECT: setState('voucherSelect'),
  SET_VOUCHERS: setState('vouchers'),

  SET_MAIN_BOXES: setState('mainBoxes'),
  SET_MAIN_BOX: setState('mainBox'),

  SET_AVAILABLE_MODULES(state, modules) {
    state.availableModules = modules
  },
  SET_TENANCY_ENABLED(state, value) {
    state.tenancyEnabled = value
  },
  SET_TENANT_ID(state, tenantId) {
    state.tenantId = tenantId
  },
  SET_MODULES_BY_SLUG(state, modulesBySlug) {
    state.modulesBySlug = modulesBySlug
  },
  SET_USER_PERMISSIONS(state, userPermissions) {
    state.userPermissions = userPermissions || []
  },
  SET_TENANT_MODULES(state, modules) {
    const modulesMap = {}
    if (Array.isArray(modules)) {
      modules.forEach((module) => {
        if (module && module.slug) {
          modulesMap[module.slug] = {
            slug: module.slug,
            name: module.name || module.slug,
            enabled: module.enabled !== undefined ? module.enabled : true,
            ...module
          }
        }
      })
    }
    state.tenantModules = modulesMap
  },
  SET_TENANT_CONFIG(state, config) {
    state.tenantConfig = config || {}
  },

  SET_IS_MAINTANANCE: setState('is_maintenance'),

  UPDATE_APPS(state, updatedApps) {
    state.apps = updatedApps
  },
  UPDATE_CAMPAIGNS(state, updatesCampaigns) {
    state.campaigns = updatesCampaigns
  },
  UPDATE_APP_ACTIVE_STATUS(state, { id }) {
    const app = state.apps.find((app) => app.id === id)
    if (app) {
      app.enabled = !app.enabled
    }
  }
}

export { systemMutations }
